define(["require", "exports", "tslib", "./EntityBase", "./EntityValidationState"], function (require, exports, tslib_1, EntityBase_1, EntityValidationState_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    tslib_1.__exportStar(EntityBase_1, exports);
    tslib_1.__exportStar(EntityValidationState_1, exports);
});
